import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'

// Auth imports
import Login from './pages/auth/Login'
import Signup from './pages/auth/Signup'
import ForgotPassword from './pages/auth/ForgotPassword'

// Error page imports
import NotFound from './pages/errors/NotFound'
import ServerError from './pages/errors/ServerError'
import BadGateway from './pages/errors/BadGateway'
import Maintenance from './pages/errors/Maintenance'

// Static page imports
import { Pricing, Docs, Company, Demo, Contact, Support, Terms, Privacy } from './pages/StaticPages'

// Module landing pages
import ModulePage from './pages/modules/ModulePage'

// Dashboard imports
import DashboardLayout from './components/dashboard/DashboardLayout'
import Overview from './pages/dashboard/Overview'
import Billing from './pages/dashboard/Billing'
import Team from './pages/dashboard/Team'
import Settings from './pages/dashboard/Settings'

// Module imports (priority order)
import Studio from './pages/dashboard/Studio'
import Payments from './pages/dashboard/Payments'
import Accounting from './pages/dashboard/Accounting'
import Relay from './pages/dashboard/Relay'
import People from './pages/dashboard/People'
import Infrastructure from './pages/dashboard/Infrastructure'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        
        {/* Static Pages */}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/company" element={<Company />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/support" element={<Support />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        
        {/* Module Landing Pages */}
        <Route path="/modules/:moduleId" element={<ModulePage />} />
        
        {/* Error Pages (for direct access/testing) */}
        <Route path="/500" element={<ServerError />} />
        <Route path="/502" element={<BadGateway />} />
        <Route path="/maintenance" element={<Maintenance />} />
        
        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Overview />} />
          <Route path="billing" element={<Billing />} />
          <Route path="team" element={<Team />} />
          <Route path="settings" element={<Settings />} />
          
          {/* Module Routes (priority order) */}
          <Route path="studio/*" element={<Studio />} />
          <Route path="payments/*" element={<Payments />} />
          <Route path="accounting/*" element={<Accounting />} />
          <Route path="relay/*" element={<Relay />} />
          <Route path="people/*" element={<People />} />
          <Route path="infrastructure/*" element={<Infrastructure />} />
        </Route>
        
        {/* 404 Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
